export default __webpack_public_path__ + "static/media/icon_trigger_active.a6e3f64a.svg";